import {ConstantList} from './constant-list';

export class AdvertisingPlatform extends ConstantList {
  override toString(): string {
    return this.name;
  }
}
